module.exports = __webpack_public_path__ + "static/media/electric-charge.65fa551d.svg";